import {
    TransactionTemplates,
    ScenarioTemplates,
    ImpactTemplates,
    BMITemplates,
    SALTemplates,
    bindScenarioParams,
    bindImpactsParams,
    bindScenarioId,
    bindBMIParams,
    bindSALParams,
    TABLES
} from './Templates';

export class ScenarioQueryBuilder {
    constructor(scenario, impacts, bmiRecords, salRecords, entityMapper) {
        this.scenario = scenario;
        this.impacts = impacts ?? [];
        this.bmiRecords = bmiRecords ?? [];
        this.salRecords = salRecords ?? [];
        this.entityMapper = entityMapper;
        this.bindings = new Map();
        this.isNewScenario = !scenario?.scenarioId;
    }

    build() {
        const sqlParts = [
            TransactionTemplates.wrapper,
            this._scenarioUpsert(),
            this._impactsInsert(),
            this._salUpsert(),
            this._bmiUpsert(),
            'COMMIT TRANSACTION;',
            TransactionTemplates.end
        ].filter(Boolean);

        return {
            query: sqlParts.join('\n'),
            bindings: Object.fromEntries(this.bindings)
        };
    }

    _scenarioUpsert() {
        bindScenarioParams(this.bindings, this.scenario, this.entityMapper);

        if (!this.isNewScenario) {
            bindScenarioId(this.bindings, this.scenario);
            return ScenarioTemplates.updateExisting(this.entityMapper);
        }
        return ScenarioTemplates.insertNew(this.entityMapper);
    }

    _genericUpsert(records, bindFn, template, tableConstant) {
        if (!records?.length || !this.entityMapper?.[tableConstant]) {
            return '';
        }

        bindFn(this.bindings, records, this.entityMapper);
        if (!this.isNewScenario) {
            bindScenarioId(this.bindings, this.scenario);
        }

        return template.build(this.isNewScenario, records.length, this.entityMapper);
    }

    _impactsInsert() {
        return this._genericUpsert(
            this.impacts,
            bindImpactsParams,
            ImpactTemplates,
            TABLES.IMPACTS
        );
    }

    _bmiUpsert() {
        return this._genericUpsert(
            this.bmiRecords,
            bindBMIParams,
            BMITemplates,
            TABLES.BMI
        );
    }

    _salUpsert() {
        return this._genericUpsert(
            this.salRecords,
            bindSALParams,
            SALTemplates,
            TABLES.SAL
        );
    }
}
